import { useTskContext } from '@Hooks/useTskContext';
import { OverviewDTO } from '@Models/Overview.types';
import { getContextId, useSearchParam } from '@tlx/astro-shared';
import { TextCell, Tooltip, TooltipContent, TooltipTrigger } from '@tlx/atlas';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

export function DisplayName({ item }: { item: OverviewDTO }) {
    const intl = useIntl();
    const content = useSearchParam('content', 'transactions');
    const { isPilotSalaryRun } = useTskContext();
    return (
        <TextCell
            key={'displayName'}
            className={classNames('atl-p-8', 'atl-flex-col', 'atl-justify-start', 'atl-items-start')}
        >
            <div>
                <a href={getHref(content, item, isPilotSalaryRun) + `&contextId=${getContextId()}`}>
                    {item.displayName}
                </a>
                {item.reversedVoucherDisplayName && (
                    <span className={'atl-ml-2 atl-truncate'}>
                        (
                        {intl
                            .formatMessage({
                                id: 'tsk_reversing',
                            })
                            .toLowerCase()}{' '}
                        {item.reversedVoucherDisplayName})
                    </span>
                )}
                {item.reversedBy && (
                    <span className={'atl-ml-2 atl-truncate'}>
                        (
                        {intl
                            .formatMessage({
                                id: 'tsk_reversed_by',
                            })
                            .toLowerCase()}{' '}
                        {item.reversedBy})
                    </span>
                )}
            </div>
            <div className={'atl-mt-4 atl-max-w-full'}>
                <Tooltip>
                    <TooltipTrigger>
                        <div className={'atl-text-grey-60 atl-comment-font-12 atl-max-w-full atl-truncate'}>
                            {item.comment}
                        </div>
                    </TooltipTrigger>
                    <TooltipContent>{item.comment}</TooltipContent>
                </Tooltip>
            </div>
        </TextCell>
    );
}

const getHref = (content: string | null, dto: OverviewDTO, isPilotSalaryRun: boolean) => {
    if (content === 'reimbursement') {
        return `/execute/reimbursementMenu?reimbursementId=${dto.id}`;
    } else if (content === 'pension') {
        return `/execute/reimbursementMenu?obligatoryPensionId=${dto.id}`;
    } else {
        if (!isPilotSalaryRun) {
            return `/execute/wageTransactionMenu?wageTransactionId=${dto.id}`;
        }
        return `/execute/salary?salaryTransactionId=${dto.id}`;
    }
};
